/**
 * When adding new icons make sure to remove width and height from the svg element
 */
import programCosmetic from '../../assets/icons/Cosmetic.svg';
import programDental from '../../assets/icons/Dental.svg';
import programHomeImprovement from '../../assets/icons/HomeImprovement.svg';
import programVet from '../../assets/icons/Vet.svg';
import programVision from '../../assets/icons/Vision.svg';

export default {
  programCosmetic,
  programDental,
  programHomeImprovement,
  programVet,
  programVision,
};
